query GetDomainFeatureStatuses {
    domainFeatureStatuses {
        key
        status
        fromDomain {
            id
            name
        }
        fqdn
    }
}
